<template>
  <div>

    <validation-observer ref="form">
      <b-form @submit.prevent="save">
        <div class="w-full flex gap-2 justify-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            @click="showModalityPopupSearch = true"
            class="float-right">
            <feather-icon
                  icon="SearchIcon"
                  class="mr-50"/>
            <span class="align-middle">Buscar</span>
          </b-button>
          <!--
          <b-button variant="outline-primary" @click="showModalityPopupInclude = true" class="float-right mr-2">
            <feather-icon
              icon="PlusIcon"
              class="mr-50"/>
            <span class="align-middle">Incluir</span>
          </b-button>
          -->
        </div>
      </b-form>
    </validation-observer>

    <modality-popup
            :visible="showModalityPopupSearch"
            @selected="addModalitiesList"
            @close="closePopup"
            :filters="filtersGridModality"/>

    <div class="vx-row mt-4 mb-10">
      <div class="vx-col w-full">
        <vs-table :data="modalitysList" no-data-text="Nenhum registro encontrado">
          <template slot="thead">
            <vs-th>Nome</vs-th>
            <vs-th>Descrição</vs-th>
            <vs-th>Ação</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{data[indextr].name}}</vs-td>
              <vs-td>{{data[indextr].description}}</vs-td>
              <vs-td>
                <div class="flex flex-row gap-2">
                  <feather-icon
                    icon="Trash2Icon"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current text-danger"
                    @click="destroy(data[indextr])"/>
                  </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BButton, BFormInput, BFormGroup, BFormCheckbox, BInputGroupAppend, BInputGroup
} from 'bootstrap-vue'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import ModalityPopup from '../../modality/ModalityPopup.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BInputGroupAppend,
    BInputGroup,
    // validations
    ValidationProvider,
    ValidationObserver,
    //
    ModalityPopup,
  },
  props: {
    services: {
      type: Object,
      default: null
    },
    entityId: {
      type: Number,
      default: null
    },
    people_id: {
      type: Number,
      default: null
    },
    serviceDelegate: {
      type: Function
    }
  },
  data: () => ({
    id: null,
    showModalityPopupSearch: false,
    showModalityPopupInclude: false,
    modality: {
      id: null,
      name: null,
      description: null,
    },
    modalitysList: [],
    editMode: false,
    // validation rules
    required,
  }),
  computed: {

  },
  watch: {},
  methods: {
    destroy(entity) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.acceptDestroy(entity)
        }
      })
    },
    acceptDestroy(entity) {
      this.$vs.loading()
      this.serviceDelegate.deleteModality(this.entityId, entity.id).then(
          data => {
            this.$vs.loading.close()
            this.modalitysList = this.modalitysList.filter(element => {
              return element.id !== entity.id
            })

            this.notifySuccess(this.$vs)
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    clearFields() {
      this.modality.name = null
    },
    loadData() {
      this.serviceDelegate.getAllModalities(this.entityId).then(
        response => {
          this.modalitysList = Array.from(response)
        },
        error => {this.$vs.loading.close()}
      ).finally(() => {this.$vs.loading.close()})
    },
    addModalitiesList(list = null) {
      if (list && this._.isArray(list) && list.length > 0) {
        const entityList = []

        list.forEach(
          (entity) => entityList.push(entity)
        )
        this.addModalities(entityList)
      }
    },
    addModalities(ids) {
      this.$vs.loading()
      if (this.entityId) {
        this.serviceDelegate.attachModalities(this.entityId, ids).then(
          response => {
            this.notifySuccess(this.$vs, this.$t('messages.success'))
            this.loadData()
          },
          error => {this.notifyError(this.$vs, 'Não foi possível adicionar o(s) professor(es)!')}
        ).finally(() => {this.$vs.loading.close()})
      }
    },
    updateGrid() {
      this.loadData()
    },
    closePopup(show) {
      this.showModalityPopupSearch = show
    },
  },
  beforeMount() {

  },
  beforeDestroy() {

  },
  mounted() {
    this.loadData()
  }
}
</script>
